import { useTheme } from '@mui/material';
const useSSearchInputStyles = () => {
    const theme = useTheme();
    return {
        searchbarStyles: {
            gap: 1,
            input: {
                fontSize: 13,
                fontWeight: 600,
                color: theme.palette.text.primary,
                '&::placeholder': {
                    color: theme.palette.text.primary
                }
            }
        }
    };
};
export default useSSearchInputStyles;
